import useProfiler from "../../../hooks/useProfiler";
import { createMicroConversionTrackingUtils } from "..";
import { useCallback } from "react";

export const utils = createMicroConversionTrackingUtils({
  name: "flights_web_meta_to_sr_aa",
  stages: {
    main: 1,
    desktop: 2,
    mobile: 3,
    us: 4
  },
  defaultStage: 1,
  mainStage: 1,
  goals: {},
  goalsWithValue: []
});

// We already know the flight is available because it does not come from erroneous search results
export function useTrackStages() {
  const { isMeta, isMobile, isAmerican } = useProfiler();

  return useCallback(() => {
    if (isMeta()) {
      const stages = utils.stages;
      stages.main();
      isMobile() ? stages.mobile() : stages.desktop();
      isAmerican() && stages.us();
    }
  }, [isMeta, isMobile, isAmerican]);
}

export default { ...utils, useTrackStages };
